import {
  GET_OUTLET,
  UPDATE_OUTLET,
} from '../types';
import { ThrowErrorMsg } from '../util';
import apiService from '../../services.js/apiService';

export const getOutlet = (id) => async (dispatch) => {
  try {
    const outlet = await apiService.getOutlet(id);
    dispatch({ type: GET_OUTLET });
    return outlet;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};

export const updateOutlet = (id, data) => async (dispatch) => {
  try {
    const outlet = await apiService.updateOutlet(id, data);
    dispatch({ type: UPDATE_OUTLET, payload: outlet });
    return outlet;
  } catch (err) {
    ThrowErrorMsg(err);
  }
};
